<template>
  <div>
    <div class="u-input-select w-max fz85 fw-b">
      <select :name="propName" class="w-max" v-model="selected" @change="handleInput">
        <option :value="value" v-for="{ label, value } in selectOptions">{{ label }}</option>
      </select>
    </div>
    <p class="c-red" v-for="error in errors">{{ error }}</p>
  </div>
</template>

<script>
export default {
  props: {
    propName: String,
    propValue: [String, Number],
    propOptions: {
      type: Object,
      default: () => ({}),
    },
    propOptional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.propValue,
      lastEmitted: null,
      selectOptions: [],
      errors: [],
    }
  },
  created() {
    this.selectOptions = this.propOptions.select_options || [];
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.propOptional && (this.selected == null || String(this.selected).trim() === '')) {
        errors.push('選択してください');
      }
      return errors;
    },
    handleInput() {
      this.errors = this.getErrors();
      const event = this.errors.length === 0 ? 'valid' : 'invalid';
      if (event !== this.lastEmitted) {
        this.lastEmitted = event;
        this.$emit(event);
      }
    },
    validate() {
      const event = this.getErrors().length === 0 ? 'valid' : 'invalid';
      this.lastEmitted = event;
      this.$emit(event);
    }
  },
}
</script>
